<div *ngIf="render">
  <div class="container py-5">
    <div class="row">
      <div class="col-md-12">
        <h2 class="text-center text-white mb-4">Inpress</h2>

        <div class="row">
          <div class="col-md-6 mx-auto">
            <!-- form card login -->
            <div class="card rounded-0">
              <div class="card-header">
                <h3 class="mb-0">Wachtwoord resetten</h3>
              </div>

              <div class="card-body">
                <form
                  [formGroup]="resetPasswordForm"
                  class="form"
                  role="form"
                  autocomplete="off"
                  id="formResetPassword"
                  novalidate=""
                  (submit)="resetPassword()"
                >
                  <div class="form-container">
                    <mat-form-field appearance="outline">
                      <mat-label>Wachtwoord</mat-label>
                      <input
                        matInput
                        type="password"
                        formControlName="password"
                        placeholder="Wachtwoord"
                        required
                      />
                      <mat-error>Wachtwoord is vereist</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Herhaal wachtwoord</mat-label>
                      <input
                        matInput
                        type="password"
                        formControlName="repeatPassword"
                        placeholder="Herhaal wachtwoord"
                        required
                      />
                      <mat-error>Wachtwoord herhalen is vereist</mat-error>
                    </mat-form-field>
                  </div>

                  <button
                    type="submit"
                    class="btn btn-success btn-lg float-right"
                    id="btnLogin"
                  >
                    Reset wachtwoord
                  </button>
                </form>
              </div>
              <!--/card-block-->
            </div>
            <!-- /form card login -->
          </div>
        </div>
        <!--/row-->
      </div>
      <!--/col-->
    </div>
    <!--/row-->
  </div>
</div>
